module.exports = __webpack_public_path__ + "static/media/8OLA32.28c36ef1.jpg";